export default "__VITE_ASSET__CxjkiYED__"